import { defineStore } from "pinia";
import { supabase } from "@/lib/supabase";
import type { User, Session, AuthResponse } from "@supabase/supabase-js";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null as User | null,
    session: null as Session | null,
  }),
  getters: {
    isAuthenticated: (state) => !!state.session,
  },
  actions: {
    async login(
      email: string,
      password: string
    ): Promise<AuthResponse["data"]> {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;
      this.session = data.session;
      this.user = data.user;
      return data;
    },
    async logout() {
      await supabase.auth.signOut();
      this.session = null;
      this.user = null;
    },
    async checkSession() {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      this.session = session;
      this.user = session?.user || null;
      return session;
    },
  },
});
